import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          disabled: _vm.$attrs.readonly,
          persistent: "",
          "return-value": _vm.date,
          width: _vm.width,
        },
        on: {
          "update:returnValue": function ($event) {
            _vm.date = $event
          },
          "update:return-value": function ($event) {
            _vm.date = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [
                _c(
                  VTextField,
                  _vm._g(
                    _vm._b(
                      {
                        attrs: {
                          clearable: "",
                          value: _vm.customTextFormat(_vm.date),
                          label: _vm.label,
                          "prepend-icon": _vm.icon,
                          readonly: _vm.textFieldReadonly,
                        },
                        on: {
                          "click:clear": function ($event) {
                            _vm.date = undefined
                          },
                        },
                      },
                      "v-text-field",
                      { ...attrs, ..._vm.$attrs },
                      false
                    ),
                    on
                  )
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.modal,
          callback: function ($$v) {
            _vm.modal = $$v
          },
          expression: "modal",
        },
      },
      "v-dialog",
      _vm.dialogProps,
      false
    ),
    [
      _vm._v(" "),
      _c(
        VDatePicker,
        _vm._b(
          {
            attrs: {
              "full-width": "",
              scrollable: "",
              locale: _vm.convertLocale(_vm.currentLocale, "bcp47"),
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          },
          "v-date-picker",
          _vm.datePickerProps,
          false
        ),
        [
          _c(
            VBtn,
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function ($event) {
                  _vm.modal = false
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("common.cancel")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function ($event) {
                  _vm.date = undefined
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("common.clear")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(VSpacer),
          _vm._v(" "),
          _c(
            VBtn,
            {
              attrs: { color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$refs.dialog.save(_vm.date)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("common.ok")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }